import standard from "./standard";

//TODO: fix colors for landscape.man_made, poi.attraction, landscape:labels.icon, and anything else
// const light = [
//     ...standard,
//     {
//         featureType: "landscape",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: grey5,
//             },
//         ],
//     },
//     {
//         featureType: "landscape.natural.terrain",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: confirmation10,
//             },
//         ],
//     },
//     {
//         featureType: "poi.business",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: grey10,
//             },
//         ],
//     },
//     {
//         featureType: "poi.business",
//         elementType: "geometry.fill",
//         stylers: [
//             {
//                 color: grey10,
//             },
//         ],
//     },
//     {
//         featureType: "poi.business",
//         elementType: "labels.text.fill",
//         stylers: [
//             {
//                 color: grey60,
//             },
//         ],
//     },
//     {
//         featureType: "poi.medical",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: red5,
//             },
//         ],
//     },
//     {
//         featureType: "poi.park",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: confirmation10,
//             },
//         ],
//     },
//     {
//         featureType: "poi.sports_complex",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: confirmation40,
//             },
//         ],
//     },
//     {
//         featureType: "road",
//         elementType: "geometry.fill",
//         stylers: [
//             {
//                 color: "#ffffff",
//             },
//         ],
//     },
//     {
//         featureType: "road",
//         elementType: "geometry.stroke",
//         stylers: [
//             {
//                 color: grey15,
//             },
//         ],
//     },
//     {
//         featureType: "road",
//         elementType: "labels.text.fill",
//         stylers: [
//             {
//                 color: grey60,
//             },
//         ],
//     },
//     {
//         featureType: "road.highway",
//         elementType: "geometry.fill",
//         stylers: [
//             {
//                 color: yellow5,
//             },
//         ],
//     },
//     {
//         featureType: "road.highway",
//         elementType: "geometry.stroke",
//         stylers: [
//             {
//                 color: yellow20,
//             },
//         ],
//     },
//     {
//         featureType: "transit",
//         elementType: "geometry",
//         stylers: [
//             {
//                 color: grey3,
//             },
//         ],
//     },
//     {
//         featureType: "water",
//         elementType: "geometry.fill",
//         stylers: [
//             {
//                 color: blue5,
//             },
//         ],
//     },
// ];

// export default light;
export default standard;